/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import { notification, message } from 'antd';
// eslint-disable-next-line import/no-unresolved
import { auth } from '../../../firebase';
import * as AuthAPI from '../../../api/auth';
import { setAppIsLoading, setContentIsLoading } from '../../loading/actions';
import TEXTS from './_texts';

const lang = 'fr';

export const SET_USER = 'SET_USER';

export const setUser = value => ({
    type: SET_USER,
    payload: value,
});

export const sessionExpired = async (err, dispatch) => {
    const errMsg = TEXTS[err.code];
    if (errMsg) {
        notification.error({
            message: TEXTS.errorNotificationMessage[lang],
            description: errMsg[lang],
        });
        await auth.signOut();
        await AuthAPI.logout();
        dispatch(setUser(null));
    } else if (err.response && err.response.data && err.response.data.message) {
        if (err.response.data.code === 'auth/argument-error' || err.response.data.message.startsWith('Decoding')) {
            await auth.signOut();
            await AuthAPI.logout();
            dispatch(setUser(null));
            message.warning('Votre session à expirée, veuillez vous reconnecter.');
        } else {
            message.error("Une erreur s'est produite, l'opération à échouée");
        }
    } else {
        message.error("Une erreur s'est produite, l'opération à échouée");
    }
};


const tooManyRequestsFbError = (err) => {
    if (err.response) {
        if (err.response.data) {
            if (err.response.data.code === 'auth/internal-error') {
                notification.error({
                    message: TEXTS.errorNotificationMessage[lang],
                    description: TEXTS['auth/too-many-requests'][lang],
                });
            }
        }
    }
};

export const checkAuthAsync = fromUnconfirmed => async (dispatch) => {
    dispatch(setAppIsLoading(true));
    try {
        const authStatus = await AuthAPI.getStatus();
        if (authStatus.user) dispatch(setUser(authStatus.user));
        if (fromUnconfirmed) {
            if (!authStatus.user.email_verified) message.warning(TEXTS.emailStillUnconfirmed[lang]);
        }
    } catch (err) {
        sessionExpired(err, dispatch);
    }
    dispatch(setAppIsLoading(false));
};


export const recoverPassword = async (email) => {
    try {
        await auth.sendPasswordResetEmail(email);
        notification.success({
            message: TEXTS.notifEmailVerificationSuccessMessage[lang],
            description: TEXTS.notifPasswordResetSuccessDescription[lang],
        });
    } catch (err) {
        tooManyRequestsFbError(err);
        sessionExpired(err);
    }
};


export const sendEmailVerification = async () => {
    try {
        await AuthAPI.generatEmailVerification();
        notification.success({
            message: TEXTS.notifEmailVerificationSuccessMessage[lang],
            description: TEXTS.notifEmailVerificationSuccessDescription[lang],
        });
    } catch (err) {
        tooManyRequestsFbError(err);
        sessionExpired(err);
    }
};
export const updateUserEmail = email => async (dispatch) => {
    try {
        const res = await AuthAPI.updateMail(email);
        dispatch(setUser(res.data));
        message.success(TEXTS.updateEmailSuccess[lang]);
    } catch (err) {
        tooManyRequestsFbError(err);
        sessionExpired(err, dispatch);
    }
};

export const signUpAsync = credentials => async (dispatch) => {
    try {
        dispatch(setAppIsLoading(true));
        try {
            const res = await auth.createUserWithEmailAndPassword(
                credentials.email,
                credentials.password,
            );
            if (res.user) {
                const token = await res.user.getIdToken();
                res.user.sendEmailVerification();
                credentials._id = res.user.uid;
                credentials.token = token;
                delete credentials.password;
                const response = await AuthAPI.register(credentials);
                dispatch(setUser(response.data));
            }
        } catch (err) {
            sessionExpired(err, dispatch);
        }
        dispatch(setAppIsLoading(false));
    } catch (err) {
        sessionExpired(err, dispatch);
    }
};

export const loginAsync = credentials => async (dispatch) => {
    dispatch(setAppIsLoading(true));
    try {
        try {
            const res = await auth.signInWithEmailAndPassword(
                credentials.email,
                credentials.password,
            );
            if (res.user) {
                const idToken = await res.user.getIdToken(true);
                const id = res.user.uid;
                const response = await AuthAPI.login({ idToken, id });
                const AuthenticatedUser = response.user;
                dispatch(setUser(AuthenticatedUser));
            }
        } catch (err) {
            sessionExpired(err, dispatch);
        }
    } catch (err) {
        sessionExpired(err, dispatch);
    }
    dispatch(setAppIsLoading(false));
    return null;
};

export const disconnectAsync = () => async (dispatch) => {
    dispatch(setAppIsLoading(true));
    try {
        await auth.signOut();
        await AuthAPI.logout();
        dispatch(setUser(null));
        message.success(TEXTS.sucessDisconnect[lang]);
    } catch (err) {
        sessionExpired(err, dispatch);
    }
    dispatch(setAppIsLoading(false));
};


export const updateUserAsync = body => async (dispatch) => {
    dispatch(setContentIsLoading(true));
    try {
        const res = await AuthAPI.update(body);
        if (res.data) {
            dispatch(setUser(res.data));
        }
    } catch (err) {
        sessionExpired(err, dispatch);
    }
    dispatch(setContentIsLoading(false));
};
